export default __webpack_public_path__ + "static/media/Glitter.bb91d50c.svg";